import { useState, useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import axiosInstance from '../../api/axiosInstance';

// Full-screen, login-gated sales kit. The HTML is fetched from the [Authorize]
// SalesKitController (so it's never publicly reachable) and rendered in an
// isolated iframe via srcDoc (keeps its own styles/scripts/videos sandboxed).
export default function CompetitiveAnalysis2026() {
    const [html, setHtml] = useState(null);
    const [error, setError] = useState('');

    useEffect(() => {
        axiosInstance
            .get('/SalesKit/Competitive2026', {
                responseType: 'text',
                params: { v: Date.now() },            // cache-bust: always fetch the latest kit
                headers: { 'Cache-Control': 'no-cache' },
            })
            .then(res => {
                const raw = typeof res.data === 'string' ? res.data : '';
                // Asset URLs (embedded video) are env-relative — resolve against this origin
                // (srcDoc has no base URL of its own).
                setHtml(raw.replace(/__ASSETBASE__/g, window.location.origin));
            })
            .catch(() => setError('Unable to load the sales kit. Please make sure you are logged in.'));
    }, []);

    if (error) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', p: 3 }}>
                <Typography sx={{ fontFamily: "'Poppins', sans-serif", color: '#64748B' }}>{error}</Typography>
            </Box>
        );
    }
    if (html == null) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }
    return (
        <iframe
            title="Astern Competitive Sales Kit"
            srcDoc={html}
            style={{ position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 'none' }}
        />
    );
}
